import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../../../common/config";

export const sheetUploadService = createApi({
  reducerPath: "sheetUpload",
  baseQuery,
  endpoints: (builder) => ({
    uploadSheet: builder.mutation({
      query: (formdata) => ({
        url: `/api/users/createExcelFormulas`,
        method: "POST",
        body: formdata,
      }),
    }),
  }),
});
export const { useUploadSheetMutation } = sheetUploadService;
